import { Alert, Badge, Card, Center, Group, Image, Loader, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { errorMessage } from '../api/client';
import { newsApi } from '../api/studio';
import { PageTitle } from '../components/PageTitle';
import { ru } from '../i18n/ru';
import { formatDate } from '../studio/format';

export function NewsFeedPage() {
  const feed = useQuery({ queryKey: ['news-feed'], queryFn: newsApi.feed });

  return (
    <Stack gap="xl">
      <PageTitle title={ru.news.title} />

      {feed.isPending && (
        <Center h={120}>
          <Loader />
        </Center>
      )}

      {feed.isError && (
        <Alert color="red" title={ru.common.error}>
          {errorMessage(feed.error, ru.common.loadFailed)}
        </Alert>
      )}

      {feed.isSuccess && feed.data.length === 0 && (
        <Alert color="gray" variant="light" maw={560}>
          {ru.news.emptyFeed}
        </Alert>
      )}

      <Stack gap="md">
        {(feed.data ?? []).map((post) => (
          <Card
            key={post.id}
            padding="lg"
            component={Link}
            to={`/news/${post.slug}`}
            style={{ textDecoration: 'none' }}
          >
            <Group align="flex-start" gap="lg" wrap="nowrap">
              {post.coverImageUrl !== null && (
                <Image
                  src={post.coverImageUrl}
                  w={160}
                  h={110}
                  radius="md"
                  fit="cover"
                  visibleFrom="sm"
                  alt=""
                />
              )}

              <Stack gap="xs" style={{ minWidth: 0 }}>
                <Group gap="xs">
                  {post.publishedAt !== null && (
                    <Text size="xs" c="graphite.5">
                      {formatDate(post.publishedAt)}
                    </Text>
                  )}
                  {!post.forAllGroups &&
                    post.groupNames.map((name) => (
                      <Badge key={name} size="xs" variant="light">
                        {name}
                      </Badge>
                    ))}
                </Group>

                {/* Без заголовка главной строкой становится сам текст:
                    рисовать пустое место или «Без заголовка» незачем. */}
                {post.title === null ? (
                  <Text c="graphite.9" lineClamp={4}>
                    {post.summary}
                  </Text>
                ) : (
                  <>
                    <Text fw={600} c="graphite.9">
                      {post.title}
                    </Text>

                    {post.summary !== null && (
                      <Text size="sm" c="graphite.6" lineClamp={3}>
                        {post.summary}
                      </Text>
                    )}
                  </>
                )}
              </Stack>
            </Group>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
}
